(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ohb-home-hero-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ohb-hero-carousel')) {
  customElements.define('ohb-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-ohb-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-ohb-go]'));
      this.rotationToggle = this.querySelector('[data-ohb-toggle-autoplay]');
      this.rotationEnabled = this.dataset.autoplay === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hoverPaused = false;
      this.focusPaused = false;
      this.autoplayTimer = null;
      this.handleVisibilityChange = () => this.refreshAutoplay();
      this.handleResize = () => this.updateSectionHeight();
      window.addEventListener('resize', this.handleResize);
      this.updateSectionHeight();
      if (this.slides.length < 2) return;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-ohb-next], [data-ohb-previous], [data-ohb-go], [data-ohb-toggle-autoplay]');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-ohb-toggle-autoplay')) {
          this.rotationEnabled = !this.rotationEnabled;
          this.updateRotationToggle();
          this.refreshAutoplay();
          return;
        }
        const activeIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
        const current = activeIndex < 0 ? 0 : activeIndex;
        if (button.hasAttribute('data-ohb-next')) this.showSlide((current + 1) % this.slides.length);
        else if (button.hasAttribute('data-ohb-previous')) this.showSlide((current - 1 + this.slides.length) % this.slides.length);
        else this.showSlide(Number(button.getAttribute('data-ohb-go')));
      });
      this.addEventListener('mouseenter', () => { this.hoverPaused = true; this.refreshAutoplay(); });
      this.addEventListener('mouseleave', () => { this.hoverPaused = false; this.refreshAutoplay(); });
      this.addEventListener('focusin', () => { this.focusPaused = true; this.refreshAutoplay(); });
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) { this.focusPaused = false; this.refreshAutoplay(); }
      });
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      this.updateRotationToggle();
      this.refreshAutoplay();
    }
    disconnectedCallback() {
      window.clearInterval(this.autoplayTimer);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      window.removeEventListener('resize', this.handleResize);
    }
    updateSectionHeight() {
      const section = this.parentElement;
      if (!section) return;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const configuredHeight = Number(isMobile ? this.dataset.mobileHeight : this.dataset.desktopHeight) || (isMobile ? 850 : 650);
      section.style.height = configuredHeight + 'px';
    }
    refreshAutoplay() {
      window.clearInterval(this.autoplayTimer);
      if (!this.rotationEnabled || this.reducedMotion || this.hoverPaused || this.focusPaused || document.hidden) return;
      const duration = Number(this.dataset.autoplaySpeed) || 4000;
      this.autoplayTimer = window.setInterval(() => {
        const activeIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
        const current = activeIndex < 0 ? 0 : activeIndex;
        this.showSlide((current + 1) % this.slides.length);
      }, duration);
    }
    updateRotationToggle() {
      if (!this.rotationToggle) return;
      const pauseIcon = this.rotationToggle.querySelector('[data-ohb-pause-icon]');
      const playIcon = this.rotationToggle.querySelector('[data-ohb-play-icon]');
      this.rotationToggle.setAttribute('aria-label', this.rotationEnabled ? 'Pause automatic slide rotation' : 'Start automatic slide rotation');
      this.rotationToggle.setAttribute('aria-pressed', String(!this.rotationEnabled));
      if (pauseIcon) pauseIcon.hidden = !this.rotationEnabled;
      if (playIcon) playIcon.hidden = this.rotationEnabled;
    }
    showSlide(index) {
      const normalizedIndex = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === normalizedIndex;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      this.dots.forEach((dot, dotIndex) => {
        if (dotIndex === normalizedIndex) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      window.requestAnimationFrame(() => this.updateSectionHeight());
      this.refreshAutoplay();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
